export const BREAKPOINT_MOBILE = 320;
export const BREAKPOINT_TABLET = 767;
export const BREAKPOINT_DESKTOP = 1023;
export const BREAKPOINT_MOBILE_TEXT = 'mobile';
export const BREAKPOINT_TABLET_TEXT = 'tablet';
export const BREAKPOINT_DESKTOP_TEXT = 'desktop';
